import { render, staticRenderFns } from "./ExternalTaskBody.vue?vue&type=template&id=b84eb0dc&"
import script from "./ExternalTaskBody.vue?vue&type=script&lang=js&"
export * from "./ExternalTaskBody.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports